export function isDeviceMode() {
  return (
    (!window.location.href.includes('legacysections') &&
      window.location.href.includes('editor') &&
      !window.location.href.includes('legacyeditor')) ||
    window.location.href.includes('sections')
  );
}
